<!--
 * @Author: liushengjiang 1947448287@qq.com
 * @Date: 2021-12-28 15:26:11
 * @LastEditors: liushengjiang 1947448287@qq.com
 * @LastEditTime: 2022-12-08 11:21:38
 * @FilePath: \petro-web-chemicals-buyerc:\Users\Administrator\Desktop\买家app\petro-app-chemicals-buyer\src\views\login\Login.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="login-container">
    <Header :showAccount="showAccount"></Header>
    <Field :showAccount="showAccount" @switchLoginType="switchLoginType"></Field>
  </div>
</template>
<script>
import Header from "./components/Header.vue";
import Field from "./components/Field";
export default {
  name: "Login",
  components: {
    Header,
    Field
  },
  data() {
    return {
      showAccount: false
    };
  },
  mounted() {},
  methods: {
    switchLoginType() {
      this.showAccount = !this.showAccount;
    }
  }
};
</script>
<!-- <style>
html {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: url("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter ….3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\"/></filter></svg>#grayscale");
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  filter: gray;
  -webkit-filter: grayscale(1);
}
</style> -->
<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl'
.login-container
  height calc(100%)
  background $bgColor
  display flex
  flex-direction column
  background url('../../assets/imgs/login/bg.svg') no-repeat
  background-size cover
</style>
